import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
    {
        url: '/dashboard',
        title: 'Dashboard',
        moduloID: 0, moduloActive: false,
        icon: 'mdi mdi-folder',
        extralink: false,
        class: '',
        submenu: []

    }
];